<div mat-dialog-content class="flagContainer">
  <div class="flag" *ngFor="let flag of langs" [class]="flag" (click)="selectLang(flag)"></div>
</div>
